import './transactions.scss';
import { Enum, PaginationList } from '../../../../core/domain';
import * as React from 'react';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { getIconPath } from '../../../../core/utils/getIconPath';
import { Divider, Popover, Tag } from 'antd';
import { digitSperator, faNumToEnNum } from '../../../../core/utils/decimalExtentions';
import moment from 'jalali-moment';
import { Badge } from '../../../../components';
import { EditOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { ReactComponent as CalendarIcon } from 'assets/icons/dash-line-icons/calendar.svg';
import { getPageNum } from '../../../../core/utils/paggingHelper';
import { Card } from '../../../../components/card/card';
import { Input, inputType } from '../../../../components/input/input';
import { Button, buttonType } from '../../../../components/button/button';
import { Table } from '../../../../components/table/table';
import { Dropdown as CustomDropdown } from 'components/dropdown/dropdown';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import {
    Transaction,
    TransactionCount,
    TransactionFilterValues,
    TransactionType,
} from '../../../../core/domain/transaction/transaction';
import {
    getAllTransactions,
    getDepositCurrencyType,
    getTransactionPlatforms,
    getTransactionStates,
    getTransactionTypes,
} from '../../../../core/repositories/transaction';
import { TransactionDetailModal } from './transactio-details/transaction-detail';
import { getMarketTypes } from '../../../../core/repositories/orders';
import { Page } from 'components/page/page';
import { BadgeType } from 'components/badge/badge';
import { TransactionEditModal } from './edit-modal/edit-modal';
import { jFormat } from 'core/utils/jFormat';

const initialFilters = {
    marketType: {
        id: -1,
        title: 'نوع ارز',
    },
    state: {
        id: -1,
        title: 'همه وضعیت ها',
    },
    // sort: SortDirection.ASC,
    type: {
        id: -1,
        title: 'همه تراکنش ها',
    },
    source: {
        id: -1,
        title: 'همه مبدا ها',
    },
    platform: {
        id: -1,
        title: 'همه پلتفرم ها',
    },
    depositCurrencyType: {
        id: -1,
        title: 'نوع واریز',
    },
};

function getBadgeTypeByStateId(stateId: number): BadgeType {
    switch (stateId) {
        case 1:
            return 'waiting'; // در انتظار پرداخت
        case 2:
            return 'success'; // انجام شده
        case 3:
            return 'error'; // رد شده
        case 4:
            return 'info'; // در انتظار تایید کد
        case 5:
            return 'primary'; // در انتظار تایید ادمین
        case 6:
            return 'waiting'; // در انتظار تسویه شبکه
        case 7:
            return 'primary'; // درحال انجام دستی
        case 8:
            return 'info'; // درحال انجام
        case 9:
            return 'success'; // آماده برداشت
        case 10:
            return 'waiting'; // در انتظار ۷۲ ساعت خرید اول
        case 11:
            return 'secondary'; // در انتظار آپلود عکس و گذشت زمان
        case 12:
            return 'secondary'; // در انتظار آپلود تصویر سلفی
        case 13:
            return 'primary'; // در انتظار تایید مدرک توسط ادمین
        case 14:
            return 'info'; // در انتظار برسی عکس و گذشت زمان
        default:
            return 'secondary';
    }
}

export const Transactions = () => {
    const [transactionsList, setTransactionsList] = useState<PaginationList<Transaction>>();
    const [transactionsCount, setTransactionsCount] = useState<TransactionCount>();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [cardLoading, setCardLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingPaging, setLoadingPaging] = useState<boolean>(false);

    //Enums
    const [transactionMarketTypes, setTransactionMarketTypes] = useState<Enum[]>([initialFilters.marketType]);
    const [transactionStates, setTransactionStates] = useState<Enum[]>([initialFilters.state]);
    const [transactionTypes, setTransactionTypes] = useState<Enum[]>([initialFilters.type]);
    const [transactionSources, setTransactionSources] = useState<Enum[]>([initialFilters.source]);
    const [transactionPlatforms, setTransactionPlatforms] = useState<Enum[]>([initialFilters.platform]);
    const [depositCurrencyTypes, setDepositCurrencyTypes] = useState<Enum[]>([initialFilters.depositCurrencyType]);
    const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
    const [pageSize, setPageSize] = useState<number>(10);

    const [query, setQuery] = useState<string>('');

    const [filterValues, setFilterValues] = useState<TransactionFilterValues>(initialFilters);

    const [selectedItem, setSelectedItem] = useState<Transaction>();

    const startDateRef = useRef();
    const endDateRef = useRef();

    const columns: any[] = [
        {
            name: '#',
            id: 'index',
            selector: (row: Transaction, rowIndex: number) => rowIndex + 1,
            width: '4%',
        },

        {
            name: 'شناسه',
            id: 'trackingCode',
            width: '12%',
            selector: (row: Transaction) => row.trackingCode,
            cell: (row: Transaction) => <span className="en">{row.trackingCode}</span>,
        },
        {
            name: 'نام ارز',
            id: 'market',
            width: '8%',
            selector: (row: Transaction) => row.market.name,
            cell: (row: Transaction) => (
                <>
                    <img style={{ height: '24px', marginLeft: '6px' }} src={getIconPath(row?.market?.symbol || '')} />
                    <span className="en">{row?.market?.symbol}</span>
                </>
            ),
        },
        {
            name: 'نوع تراکنش',
            id: 'transactionType',
            width: '10%',
            selector: (row: Transaction) => row.type.title,
            cell: (row: Transaction) => (
                <>
                    <Tag color={`${row.type.id === TransactionType.Deposit ? 'green' : 'red'}`}>
                        {row.type.title}{' '}
                        {row.type.id == TransactionType.Deposit && row.depositIrtType && row.market.symbol === 'IRT'}
                    </Tag>
                </>
            ),
        },
        {
            name: 'مقدار ',
            id: 'amount',
            width: '8%',
            selector: (row: Transaction) => digitSperator(row.amount),
            cell: (record: Transaction) => (
                <div className="column-amount">
                    <span>
                        <Popover title="مقدار">{digitSperator(record?.amount)}</Popover>
                    </span>
                    {record?.type?.id === TransactionType.Withdrawal && record?.market?.symbol === 'IRT' && (
                        <p>
                            <Popover title="مبلغ جهت تسویه">{digitSperator(record?.payoutAmount)}</Popover>
                        </p>
                    )}
                </div>
            ),
        },
        {
            name: 'نام کاربر',
            id: 'createdBy',
            width: '12%',
            cell: (row: Transaction) => (
                <div className="column-createdBy">
                    <span className="name">{row.createdBy}</span>
                    <p className="phone">{row.phoneNumber}</p>
                </div>
            ),
        },
        {
            name: 'پلتفرم',
            id: 'platform',
            width: '8%',
            selector: (row: Transaction) => row.platform?.title,
            cell: (row: Transaction) => (
                <>
                    <Tag color={`${row.platform?.id === 1 ? 'blue' : 'green'}`}>{row.platform?.title}</Tag>
                </>
            ),
        },
        {
            name: 'زمان',
            id: 'createdAt',
            width: '11%',
            selector: (row: Transaction) => row.createdAt,

            cell: (row: Transaction) => (
                <div className="column-date">
                    <span className="time">{moment.utc(row.createdAt).local().format('HH:mm')}</span>

                    <span>{' - '}</span>
                    <span className="day">{moment.utc(row.createdAt).locale('fa').local().format('jYYYY/MM/DD')}</span>

                </div>
            ),
        },
        {
            name: 'وضعیت',
            id: 'state',
            width: '14%',
            selector: (row: Transaction) => row.state.id,
            cell: (row: Transaction) => <Badge text={row.state.title} type={getBadgeTypeByStateId(row.state.id)} />,
        },
        {
            name: 'عملیت',
            id: 'detail',
            width: '8%',
            cell: (row: Transaction) => (
                <div className="actions">
                    <EditOutlined
                        onClick={() => {
                            setIsEditModalOpen(true);
                            setSelectedItem(row);
                        }}
                    />
                    <InfoCircleOutlined onClick={() => handleModal(row)} />
                </div>
            ),
        },
    ];

    function handleModal(id: Transaction) {
        setIsOpen(true);
        setSelectedItem(id);
    }

    const handleEnums = async () => {
        await getMarketTypes(setLoading, setTransactionMarketTypes);
        await getTransactionStates(setLoading, setTransactionStates);
        await getDepositCurrencyType(setLoading, setDepositCurrencyTypes);
        await getTransactionPlatforms(setLoading, setTransactionPlatforms);
        await getTransactionTypes(setLoading, setTransactionTypes);
    };

    const filterHandle = () => {
        var q = '';

        if (filterValues.startDate !== '')
            q += `${q.includes('?') ? '&' : '?'}startDate=${jFormat(filterValues.startDate)}`;
        if (filterValues.endDate !== '')
            q += `${q.includes('?') ? '&' : '?'}endDate=${jFormat(filterValues.endDate)}`;
        if (filterValues.keywords) q += `${q.includes('?') ? '&' : '?'}keywords=${filterValues.keywords}`;
        if (filterValues.marketType?.id !== -1)
            q += `${q.includes('?') ? '&' : '?'}marketType=${filterValues.marketType?.id}`;
        if (filterValues.source?.id !== -1) q += `${q.includes('?') ? '&' : '?'}source=${filterValues.source?.id}`;
        if (filterValues.depositCurrencyType?.id !== -1)
            q += `${q.includes('?') ? '&' : '?'}depositCurrencyType=${filterValues.depositCurrencyType?.id}`;
        if (filterValues.type?.id !== -1 && filterValues.type !== undefined)
            q += `${q.includes('?') ? '&' : '?'}type=${filterValues.type?.id}`;
        if (filterValues.state?.id !== -1 && filterValues.state !== undefined)
            q += `${q.includes('?') ? '&' : '?'}state=${filterValues.state?.id}`;
        if (filterValues.platform?.id !== -1 && filterValues.platform !== undefined)
            q += `${q.includes('?') ? '&' : '?'}platform=${filterValues.platform?.id}`;
        setQuery(q);
        getAllTransactions(setLoading, setTransactionsList, 1, pageSize, q, setTransactionsCount);
    };

    const onFilterHandler = () => {
        getAllTransactions(setLoading, setTransactionsList, 1, pageSize, query, setTransactionsCount);
    };

    const updatePageSize = (newPageSize: number) => {
        setTransactionsCount((prevState: TransactionCount | undefined) => ({
            ...prevState!,
            pageSize: newPageSize,
        }));
    };

    useEffect(() => {
        handleEnums();
        !transactionsList &&
            getAllTransactions(
                setCardLoading,
                setTransactionsList,
                getPageNum(),
                pageSize,
                query,
                setTransactionsCount,
            );
    }, []);

    return (
        <Page title="مدیریت تراکنش‌ها" className="pmx-transactions">
            {isEditModalOpen && (
                <TransactionEditModal
                    transactionStates={transactionStates}
                    isOpen={isEditModalOpen}
                    setIsOpen={setIsEditModalOpen}
                    item={selectedItem}
                    onClose={() => {
                        getAllTransactions(
                            setCardLoading,
                            setTransactionsList,
                            1,
                            pageSize,
                            query,
                            setTransactionsCount,
                        );
                        setIsEditModalOpen(false);
                    }}
                />
            )}
            <Card title="تراکنش‌ها" blur={cardLoading}>
                <div className="filter-row">
                    <div className="fields">
                        {selectedItem && (
                            <TransactionDetailModal isOpen={isOpen} setIsOpen={setIsOpen} id={selectedItem?.id} />
                        )}
                        <Input
                            type={inputType.text}
                            value={filterValues.keywords}
                            placeholder="جستجو کنید ..."
                            className="search"
                            name="search"
                            onPressEnter={filterHandle}
                            onChange={(e) =>
                                setFilterValues({
                                    ...filterValues,
                                    keywords: e.target.value,
                                })
                            }
                        />

                        <CustomDropdown
                            items={transactionMarketTypes}
                            onChangeHandle={(value) =>
                                setFilterValues({
                                    ...filterValues,
                                    marketType: transactionMarketTypes?.find((l) => l.id === value),
                                })
                            }
                            selectedOption={filterValues.marketType}
                            defaultSelected={filterValues.marketType}
                        />

                        <CustomDropdown
                            items={transactionTypes}
                            onChangeHandle={(value) =>
                                setFilterValues({
                                    ...filterValues,
                                    type: transactionTypes?.find((l) => l.id === value),
                                })
                            }
                            selectedOption={filterValues.type}
                            defaultSelected={filterValues.type}
                        />

                        <CustomDropdown
                            items={transactionStates}
                            onChangeHandle={(value) =>
                                setFilterValues({
                                    ...filterValues,
                                    state: transactionStates?.find((l) => l.id === value),
                                })
                            }
                            selectedOption={filterValues.state}
                            defaultSelected={filterValues.state}
                        />

                        <CustomDropdown
                            items={transactionPlatforms}
                            onChangeHandle={(value) =>
                                setFilterValues({
                                    ...filterValues,
                                    platform: transactionPlatforms?.find((l) => l.id === value),
                                })
                            }
                            selectedOption={filterValues.platform}
                            defaultSelected={filterValues.platform}
                        />

                        {/*<CustomDropdown*/}
                        {/*    items={transactionSources}*/}
                        {/*    onChangeHandle={(value) => setFilterValues({*/}
                        {/*        ...filterValues,*/}
                        {/*        source: transactionSources?.find((l) => l.id === value)*/}
                        {/*    })}*/}
                        {/*    selectedOption={filterValues.source}*/}
                        {/*    defaultSelected={filterValues.source}*/}
                        {/*/>*/}

                        <CustomDropdown
                            items={depositCurrencyTypes}
                            onChangeHandle={(value) =>
                                setFilterValues({
                                    ...filterValues,
                                    depositCurrencyType: depositCurrencyTypes?.find((l) => l.id === value),
                                })
                            }
                            selectedOption={filterValues.depositCurrencyType}
                            defaultSelected={filterValues.depositCurrencyType}
                        />

                        <DatePicker
                            className="date-picker"
                            value={filterValues.startDate}
                            calendar={persian}
                            ref={startDateRef}
                            locale={persian_fa}
                            render={
                                <div>
                                    <Input
                                        value={filterValues.startDate}
                                        icon={<CalendarIcon />}
                                        placeholder="از تاریخ"
                                    />
                                </div>
                            }
                            onChange={(e) => {
                                setFilterValues({
                                    ...filterValues,
                                    startDate: e.format(),
                                });
                            }}
                        />
                        <DatePicker
                            className="date-picker"
                            value={filterValues.endDate}
                            calendar={persian}
                            ref={endDateRef}
                            locale={persian_fa}
                            render={
                                <div>
                                    <Input
                                        value={filterValues.endDate}
                                        icon={<CalendarIcon />}
                                        placeholder="تا تاریخ"
                                    />
                                </div>
                            }
                            onChange={(e) => {
                                setFilterValues({
                                    ...filterValues,
                                    endDate: e.format(),
                                });
                            }}
                        />
                    </div>

                    <Divider type="vertical" />
                    <div className="buttons">
                        <Button
                            loading={loading}
                            disabled={loading}
                            onClick={() => filterHandle()}
                            text="اعمال فیلتر"
                            type={buttonType.success}
                        />
                        <Button
                            type={buttonType.error}
                            text={'حذف فیلتر'}
                            onClick={() => {
                                setFilterValues({
                                    keywords: '',
                                    startDate: '',
                                    endDate: '',
                                    // side: initialFilters.side,
                                    source: initialFilters.source,
                                    marketType: initialFilters.marketType,
                                    platform: initialFilters.platform,
                                    depositCurrencyType: initialFilters.depositCurrencyType,
                                });
                                getAllTransactions(
                                    setCardLoading,
                                    setTransactionsList,
                                    getPageNum(),
                                    pageSize,
                                    '',
                                    setTransactionsCount,
                                );
                            }}
                        />
                    </div>
                </div>
                {transactionsList && (
                    <Table
                        filters={query}
                        setloader={setCardLoading}
                        setdata={setTransactionsList}
                        getdata={getAllTransactions}
                        pagination={transactionsCount}
                        data={transactionsList.items}
                        column={columns}
                        setPageSize={updatePageSize as Dispatch<SetStateAction<number>>}
                        pageSize={transactionsCount?.pageSize}
                        setCount={setTransactionsCount}
                        className={'transactions-table'}
                    />
                )}
            </Card>
        </Page>
    );
};
